module.exports = __webpack_public_path__ + "img/step4.bd28e5df.svg";